/**
 * Mini-jeux qui ont un daily challenge généré (seedés en DB par l'Edge
 * Function `daily-challenge-cron`). Mis à jour quand on ajoute des seeds
 * pour de nouveaux jeux. V1 : Frappe Olympique seul.
 */
export const GAMES_WITH_DAILY = new Set(['frappe-olympique']);
